import { Card, CardContent, CardHeader, CardTitle } from "@components/common/card"
import { Separator } from "@components/common/separator"
import axios from "axios"
import { DictType } from "@pma/types"
import PmsLoader from "@components/common/loader"
import { Button } from "@components/common/button"
import { useInfiniteQuery } from "@tanstack/react-query"
import { parseCookies } from "nookies"
import { ACCESS_TOKEN } from "@pma/utils/constants"
import { useAuth } from "@stores/auth-store"
import { NoteCard } from "@components/projects/notes-card"
import useTranslator from "@hooks/use-translator"
import { NOTES_BY_CURRENT_USER_ENDPOINT, SERVER_URL } from "@pma/utils/api-routes"
import { useLocation, useNavigate, useSearchParams } from "react-router-dom"
import { useEffect } from "react"

const LatestNotes = () => {
  const { translate } = useTranslator()

  const { authConfig } = useAuth()

  const accessToken = parseCookies()[ACCESS_TOKEN]

  const orgId = authConfig?.last_organization_id

  const location = useLocation()
  const navigate = useNavigate()
  const [searchParam] = useSearchParams()
  const queryKey = searchParam.get("revalidate")

  async function getNotes({ pageParam = 1 }) {
    const params = `?paging_start_page=${pageParam}&paging_per_page=10&organization_id=${orgId}`

    try {
      const response = await axios.get(SERVER_URL + NOTES_BY_CURRENT_USER_ENDPOINT + params, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      })
      return response.data
    } catch (error) {
      // console.log(error);
    }
  }

  const { data, fetchNextPage, hasNextPage, isLoading, isFetching, isFetchingNextPage, refetch } =
    useInfiniteQuery({
      queryKey: ["get-notes", orgId],
      queryFn: ({ pageParam = 1 }) => getNotes({ pageParam }),
      initialPageParam: 1,
      getNextPageParam: (lastPage, allPages) => {
        if (!lastPage?.nextPage) {
          return undefined
        }
        return allPages?.length + 1
      },
    })

  const handleLoadMoreData = async () => {
    await fetchNextPage()
  }

  const isEmpty = !data?.pages[0]?.itemsReceived

  useEffect(() => {
    if (queryKey === "tasks") {
      refetch()
      navigate(`${location.pathname}`)
    }
  }, [queryKey])

  return (
    <Card className='flex h-[70vh] flex-col items-center gap-2'>
      <CardHeader className='border-b-2 border-primary'>
        <CardTitle className='w-fit'>{translate("Latest Notes")}</CardTitle>
      </CardHeader>
      <Separator />
      <CardContent className='flex w-full flex-col gap-3 overflow-y-auto overflow-x-hidden px-2'>
        {isLoading ? (
          <div style={{ width: "100%" }}>
            <PmsLoader />
          </div>
        ) : (
          <>
            {data &&
              data.pages?.map((page) =>
                page?.items?.map((note: DictType) => <NoteCard note={note} key={note.id} />),
              )}

            {isEmpty && !isFetching && (
              <small className='flex h-full w-full items-center justify-center'>
                {translate("No Notes found")}{" "}
              </small>
            )}
            {isFetchingNextPage && (
              <div style={{ width: "100%" }}>
                <PmsLoader />
              </div>
            )}
            {hasNextPage ? (
              <Button variant={"link"} className='text-primary' onClick={handleLoadMoreData}>
                {translate("Load More")}
              </Button>
            ) : null}
          </>
        )}
      </CardContent>
    </Card>
  )
}

export default LatestNotes
